import { KEYCODES } from '../config';

class BfvProfileStageLightbox {
  constructor(options = {}) {
    this.$root = options.element;
    this.$wrapper = this.$root.closest('.js-lightbox-wrapper');
    this.$player = this.$wrapper.querySelector('.bfv-liveticker-player--has-image');
    this.$team = this.$wrapper.querySelector('.bfv-profile-stage__team--has-image');
    this.$teaser = this.$player || this.$team;
    this.$closeButton = this.$root.querySelector('.js-close-button');
  }

  init() {
    if (!this.$teaser) {
      return;
    }
    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('keydown', (event) => {
      const key = event.keyCode || event.which;
      if (key === KEYCODES.ESCAPE) {
        this.closeLightbox();
      }
    }, true);

    this.$closeButton.addEventListener('click', () => this.closeLightbox());
    this.$teaser.addEventListener('click', () => this.openLightbox());
  }

  openLightbox() {
    this.$root.classList.remove('bfv-gallery-lightbox--closed');
    this.$root.classList.add('bfv-gallery-lightbox--open');
  }

  closeLightbox() {
    this.$root.classList.remove('bfv-gallery-lightbox--open');
    this.$root.classList.add('bfv-gallery-lightbox--closed');
  }
}


export default BfvProfileStageLightbox;
